module.exports = __webpack_public_path__ + "static/media/79.ec81af89.jpg";